export default {"src":"/_next/static/media/pending-blue.7cd4c9ce.svg","height":73,"width":65,"blurWidth":0,"blurHeight":0};